// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__yrH6h","title":"Info_title__c3tOq","links":"Info_links__3sb-I","link":"Info_link__sD2PD","logo":"Info_logo__Lb_lj"};